// Generated from source/ by scripts/generate.ts. Do not edit by hand.
import type { IconData } from "../types.js";

const m0 =
  '<path d="M22 17A3 3 0 0 1 19 20H5A3 3 0 0 1 2 17V10H22ZM15 14A1 1 0 1 0 15 16H18A1 1 0 1 0 18 14ZM19 4A3 3 0 0 1 22 7V8H2V7A3 3 0 0 1 5 4Z"/>';

/** Credit Card (commerce). */
const icon: IconData = {
  id: "credit-card",
  name: "Credit Card",
  category: "commerce",
  styles: {
    rounded: { svg: m0 },
    sharp: { svg: m0 },
    outline: {
      svg: '<path fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M21 9H3M17 14H14M5 19H19A2 2 0 0 0 21 17V7A2 2 0 0 0 19 5H5A2 2 0 0 0 3 7V17A2 2 0 0 0 5 19Z"/>',
    },
    duotone: {
      svg: '<g opacity=".32"><path d="M19 4L19.98 4.18 20.34 4.33 20.97 4.76 21.24 5.03 21.67 5.66 21.82 6.02 22 7 21.98 17.2 21.82 17.98 21.67 18.34 21.24 18.97 20.97 19.24 20.34 19.67 19.98 19.82 19 20 4.8 19.98 4.02 19.82 3.66 19.67 3.03 19.24 2.76 18.97 2.33 18.34 2.18 17.98 2 17 2.02 6.8 2.18 6.02 2.33 5.66 2.76 5.03 3.03 4.76 3.66 4.33 4.02 4.18 5 4Z"/></g><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M21 9H3M17 14H14M5 19H19A2 2 0 0 0 21 17V7A2 2 0 0 0 19 5H5A2 2 0 0 0 3 7V17A2 2 0 0 0 5 19Z"/>',
    },
  },
  animation: () => import("../animations/credit-card.js"),
};

export default icon;
